import React from 'react';
import { Button, Modal, ModalHeader } from 'react-bootstrap';
import { isNotEmpty } from 'app/shared/utils/utilityFunctions';
import { NotificationBannerProps } from 'app/services/api/commonTypes';
import NotificationBanner from './NotificationBanner';

export interface ConfirmationModalProps {
    showModal: boolean;
    modalHeaderText: string;
    submitBtnText: string;
    cancelBtnText?: string;
    messageText: string;
    handleSuccessAction: () => void | Promise<void>;
    handleCancelAction?: () => void;
    isSubmitDisabled?: boolean;
    showNotificationBanner?: boolean | false;
    notificationBannerProps?: NotificationBannerProps;
    onCloseNotificationBanner?: () => void;
    buttonAutoWidth?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    showModal,
    modalHeaderText,
    submitBtnText,
    cancelBtnText,
    messageText,
    handleSuccessAction,
    handleCancelAction: handleCancelSuccessModal,
    isSubmitDisabled = false,
    showNotificationBanner,
    notificationBannerProps,
    onCloseNotificationBanner,
    buttonAutoWidth = true,

}) => {
        const isSuccess = notificationBannerProps?.type === 'success';
        const autoWidthClassName = buttonAutoWidth ? 'w-auto' : '';
        return (
    <Modal
        show={showModal}
        centered
        style={{ zIndex: '9999' }}
        className="confirmationModal"
    >
    <div className="confirmationModalContainer">
        <div className="confirmationModalMainContent">
            <ModalHeader className="confirmationModalHeadingContainer p-0">
                <div className="termsHeaderFrame">
                    <h4 className="termsTitleText">
                        {modalHeaderText}
                    </h4>
                </div>
            </ModalHeader>
            <Modal.Body className="p-0">
                <div className="confirmationModalBody">
                    <div className="confirmationModalBodySubContent">
                        {showNotificationBanner && notificationBannerProps && (
                            <NotificationBanner
                                message={(
                                    <>
                                        <p className="m-0">{notificationBannerProps.headerText}</p>
                                        <p className={`m-0 font-sub ${isSuccess ? "successMsg" : "errorMsg"}`}>
                                            {notificationBannerProps.subText}
                                        </p>
                                    </>
                                )}
                                type="error"
                                onClose={onCloseNotificationBanner ?? (() => { })}
                            />
                        )}
                        <div>
                        <h2 className="confirmationModalBodySubText">
                            {messageText}
                        </h2>
                        </div>
                    </div>
                    <div className="confirmationModalButtonContent">
                        {isNotEmpty(cancelBtnText) && (
                            <Button
                                className={`mt-0 secondary-button lh-1 d-flex align-items-center justify-content-center ${autoWidthClassName}`}
                                aria-label={cancelBtnText}
                                onClick={handleCancelSuccessModal}
                            >
                                {cancelBtnText}
                            </Button>
                        )}
                        {isNotEmpty(submitBtnText) && (
                            <Button
                                className={`order-now-card-button mt-0 ${autoWidthClassName}`}
                                aria-label={submitBtnText}
                                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                onClick={handleSuccessAction}
                                disabled={isSubmitDisabled}
                            >
                                {submitBtnText}
                            </Button>
                        )}
                    </div>
                </div>
            </Modal.Body>
        </div>
    </div>
    </Modal >
                        );
                    };

export default ConfirmationModal;
